import React from "react";
import { useDimensions } from "../Util";
import { useLocation } from "react-router-dom";
import GeneralAddictionBody from "../LandingPage/AddictionsContainer/AddictionBody/GeneralAddictionBody";
import ComingSoon from "../LandingPage/AddictionsContainer/AddictionBody/ComingSoon";
import MotivationPill from "../LandingPage/WalletAndMotivationContainer/MotivationPill";
import DeveloperNote from "../LandingPage/DeveloperNote";

const PopupRenderer = () => {

    const {w,h} = useDimensions();
    const location = useLocation();
    const state = location.state;


    const contentStyle = {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
        background: "#393E46",
        padding: "20px",
        borderRadius: "8px",
        width: w > h ? "50%" : "85%",
        height: w > h ? "70%" : "70%",
        border: "6px solid #00ADB5"
    }

    const overlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 999,
        background: "rgba(0, 0, 0, 0.5)",
    }

    const components = {
        general: <GeneralAddictionBody id={state.origin} question={state.question} penalty={state.penalty} punishment={state.punishment} image={state.image}></GeneralAddictionBody>,
        comingsoon: <ComingSoon></ComingSoon>,
        motivationPill:<MotivationPill></MotivationPill>,
        developerNote:<DeveloperNote></DeveloperNote>
    };


    return <div id="large-popup">
        <div id="popup-content" style={contentStyle}>
            {components[state.type] || <div>Component not found!</div>}
        </div>
        <div id="popup-overlay" style={overlayStyle}></div>
    </div>
}

export default PopupRenderer;